import script from "./grnhomeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./grnhomeForm.vue?vue&type=script&setup=true&lang=js"

import "./grnhomeForm.vue?vue&type=style&index=0&id=1f4a5d07&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4a5d07"]])

export default __exports__